<template>
    <div class="page-content" id="p">
        <div class="detail-body">
            <div class="detail-content">
                <div class="content-head">
                    <div class="detail-title">
                        <div class="title-name">{{detail.title}}</div>
                        <div v-if="detail.is_collection===1" @click="setCollection('del')" class="title-right" style="margin-left: auto;">
                            <i class="el-icon-star-off color-red"></i>
                            <span class="color-red">已收藏</span>
                        </div>
                        <div v-else class="title-right" @click="setCollection('add')" style="margin-left: auto;">
                            <i class="el-icon-star-off"></i>
                            收藏
                        </div>
                        <el-popover
                                placement="bottom-start"
                                title="分享"
                                width="200"
                                trigger="hover">
                            <div slot="reference" class="title-right">
                                <i class="el-icon-share"></i>
                                分享
                            </div>
                            <div data-sites="qzone, qq, weibo, wechat" class="social-share"></div>
                        </el-popover>
                    </div>
                    <div class="head-address">
                        <i class="el-icon-location"></i>
                        <div class="f-14">{{detail.address}}</div>
                        <img src="./../../assets/img/bmap.jpg" class="bmap-img" alt="">
                        <div class="f-l4 cur-p color-red" @click="lookMap">查看地图</div>
                    </div>
                    <div class="swiper-content">
                        <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                            <swiper-slide class="swiper-slide" v-for="(item,index) in detail.image" :key="index">
                                <img :src="`/api/v1/file/${item}`" alt="">
                            </swiper-slide>
                            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                        </swiper>
                        <!-- swiper2 Thumbs -->
                        <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                            <swiper-slide class="swiper-slide" v-for="(item,index) in detail.image" :key="index">
                                <img :src="`/api/v1/file/${item}?w=126&h=70`" alt="">
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="content-body">
                    <div class="content-title">美食介绍</div>
                    <div class="content-text" v-html="content"></div>

                    <div class="color-grays f-14 mt-10 mb-10 tran-content">
                        是否使用谷歌翻译
                        <template v-if="!traning">
                            <el-link class="ml-20" type="primary" @click="trans('zh')">翻译为中文</el-link>
                            <el-link class="ml-10" type="primary" @click="trans('jp')">翻译为日文</el-link>
                        </template>
                        <el-link v-else class="ml-10" type="primary">翻译中...</el-link>
                    </div>
                    <div class="content-text" v-for="(item,index) in transList" :key="index">{{item.dst}}</div>

                    <div class="content-title">到达方式</div>
                    <div class="content-text">{{detail.arrival_pattern}}</div>

                    <div class="content-title">开放时间</div>
                    <div class="content-text">{{detail.opening_time}}</div>

                    <div class="content-title">电话号码</div>
                    <div class="content-text">{{detail.tel}}</div>

                    <div class="content-title">人均消费</div>
                    <div class="content-text color-red">{{detail.currency}}：{{(+detail.per_capita||0)|parseMoney}}</div>

                    <div class="content-title" id="houseMap">所在位置</div>
                    <baidu-map class="map-content"
                               scroll-wheel-zoom
                               :center="{lng: detail.longitude,lat: detail.latitude}"
                               :zoom="14">
                        <bm-circle v-if="detail.latitude" :center="{lng: detail.longitude,lat: detail.latitude}"
                                   :radius="500"
                                   :stroke-opacity="0"
                                   fillColor="blue"
                                   stroke-color="none"
                                   :fill-opacity="0.3"></bm-circle>
                    </baidu-map>
                </div>
                <div v-if="detail.house.length" class="content-title" style="padding: 0 20px;">附近房源</div>
                <div v-if="detail.house.length" class="card-content" style="width: 100%;">
                    <template v-for="(item,index) in detail.house">
                        <HouseCard :key="index" :item="item" v-if="index<12"></HouseCard>
                    </template>
                </div>
                <div class="comment-content">
                    <div class="content-title">用户评价</div>
                    <div class="comment-row">
                        <div class="comment-label">星级</div>
                        <el-rate v-model="commentForm.star" show-score></el-rate>
                    </div>
                    <div class="comment-row">
                        <div class="comment-label">内容</div>
                        <el-input type="textarea"
                                  placeholder="我也来说两句..."
                                  v-model="commentForm.assess"
                                  :autosize="{ minRows: 4, maxRows: 8}"
                                  maxlength="1000" show-word-limit></el-input>
                    </div>
                    <div class="comment-row">
                        <div class="comment-label"></div>
                        <el-button type="primary" :loading="loading" size="mini" @click="cateEvaluate">参与评论</el-button>
                    </div>
                    <CommentItem v-for="item in commentList"
                                 :key="item.id"
                                 :star="item.star"
                                 :name="item.nickname"
                                 :text="item.assess"
                                 :time="item.created_at"
                                 :head="item.portrait"></CommentItem>
                </div>
            </div>
            <div class="detail-right">
                <div class="detail-right-content">
                    <div class="right-title">相似美食</div>
                    <SmallCard class="mb-10 cur-p"
                               v-for="(item,index) in detail.other"
                               @click="toCateDetail(item)"
                               :key="index" :url="item.cover"
                               :name="item.title"></SmallCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HouseCard from "@/components/HouseCard";
    import SmallCard from "../../components/SmallCard";
    import CommentItem from "../../components/CommentItem";

    export default {
        name: "cateDetail",
        components:{HouseCard, SmallCard, CommentItem},
        data() {
            return {
                id: '',
                loading: false,
                traning: false,
                transList: [],
                detail: {
                    house: []
                },
                content: '',
                checkInRules: '',
                swiperOptionTop: {
                    loop: true,
                    loopedSlides: 5, // looped slides should be the same
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                swiperOptionThumbs: {
                    loop: true,
                    spaceBetween: 10,
                    loopedSlides: 5, // looped slides should be the same
                    slidesPerView: 5,
                    touchRatio: 0.2,
                    direction: 'vertical',
                    slideToClickedSlide: true,
                    centeredSlides: false
                },
                commentForm:{
                    star: 5,
                    assess: ''
                },
                commentList: [],
                config: {
                    title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                    description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                    image: '', // 图片, 默认取网页中第一个img标签
                    sites: ['qzone', 'qq', 'weibo', 'wechat']
                }
            }
        },
        computed:{
            exchangeJP() {
                let jp = this.detail.money2.find((value)=> value.coin_name === 'JPY')
                if(!jp) return 0;
                let ratio = +jp.ratio;
                return ratio / 100
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.getCate();
            setTimeout(() => {
                app.scrollTop = 0;
            }, 0)
        },
        methods: {
            async trans(to){
                this.traning = true;
                let [e, data] = await this.$api.transApi({to, q: this.detail.content})
                this.traning = false;
                this.transList = data.result;
            },
            async getCate() {
                let [e, data] = await this.$api.getCateApi({
                    id: this.id
                })
                this.detail = data.result;
                if(this.detail.content){
                    this.content = this.detail.content.replace(/\n/g, '<br>')
                }
                if(this.detail.house.check_in_rules){
                    this.checkInRules = this.detail.check_in_rules.replace(/\n/g, '<br>')
                }
                this.commentList = this.detail.evaluate;
                this.$nextTick(() => {
                    const swiperTop = this.$refs.swiperTop.$swiper
                    const swiperThumbs = this.$refs.swiperThumbs.$swiper
                    swiperTop.on('slideChange',(r)=>{
                        swiperThumbs.slideToLoop(r.realIndex, 500)
                    })
                    swiperThumbs.on('slideChange',(r)=>{
                        swiperTop.slideToLoop(r.realIndex, 500)
                    })
                })
                this.config.title = this.detail.title;
                this.config.description = this.detail.title;
                this.config.image = this.detail.cover;
                socialShare('.social-share', this.config)
            },
            lookMap(){
                houseMap.scrollIntoView()
            },
            toCateDetail({id}){
                this.$router.push({path: '/cateDetail',query:{id}})
            },
            async cateEvaluate(){
                if(!this.commentForm.assess){
                    return this.$message.warning('请输入评论内容！')
                }
                this.loading = true;
                let [e, data] = await this.$api.cateEvaluateApi({
                    id: this.id, ...this.commentForm
                })
                this.loading = false;
                if(data.code === 200){
                    this.$message.success('评论成功');
                    this.commentForm.star = 5;
                    this.commentForm.assess = '';
                    this.cateAllEvaluate();
                }else{
                    this.$message.success(data.msg);
                }
            },
            async cateAllEvaluate(){
                let [e, data] = await this.$api.cateAllEvaluateApi({id: this.id})
                if(data.code === 200){
                    this.commentList = data.result;
                }
            },
            async setCollection(method){
                let [e, data] = await this.$api.setCollectionApi({
                    id: this.detail.id,
                    mark: 3,
                    method
                })
                if(data.code === 200){
                    if(method==='add'){
                        this.detail.is_collection = 1;
                    }else {
                        this.detail.is_collection = 0;
                    }
                }else{
                    this.$message.warning(data.error)
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .page-content {
        display: flex;
        padding-bottom: 30px;
    }

    .detail-body {
        width: 1200px;
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .detail-content {
        width: 900px;
        margin-right: 20px;
        background-color: #ffffff;
        box-shadow: 3px 3px 6px #A6A6A6;

        .content-head {
            width: 100%;
            padding: 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;

            .detail-title {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .title-name {
                    font-size: 26px;
                }

                .title-right {
                    padding-left: 20px;
                    cursor: pointer;
                }
            }

            .head-address {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #949494;
                margin: 4px 0;

                .bmap-img {
                    margin-left: 20px;
                    margin-right: 10px;
                }
            }
            .head-bottom{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding-top: 20px;
                .head-bottom-icon{
                    width: 30px;
                    height: 30px;
                    object-fit: contain;
                    margin-right: 10px;
                }
                .icon-text{
                    margin-right: 20px;
                }
            }
        }
        .content-body{
            padding: 10px 30px 30px 30px;
            box-sizing: border-box;
            width: 100%;
            text-align: left;
            border-bottom: 1px solid #e2e2e2;
        }
    }

    .detail-right {
        flex: 1;
        position: sticky;
        top: 100px;
        left: 0;
        z-index: 2;

        .detail-right-content{
            padding: 20px;
            background-color: #ffffff;
            box-shadow: 3px 3px 6px #A6A6A6;
            text-align: left;
            margin-bottom: 20px;
            .right-title{
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .evaluate-content{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .btn-item{
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                text-align: center;
                margin-top: 20px;
                cursor: pointer;
            }
            .img-row{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 10px;
                cursor: pointer;
                img{
                    width: 40px;
                    height: 40px;
                    border-radius: 100%;
                    object-fit: cover;
                    margin-right: 10px;
                }
                .nick-name{
                    font-weight: bold;
                }
                &:hover{
                    .nick-name{
                        color: #e44646 !important;
                    }
                }
            }
        }
    }

    .swiper-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .gallery-top {
            width: 694px;
            height: 390px;
            margin-right: 20px;
        }
        .gallery-thumbs{
            width: 126px;
            height: 390px;
        }
        .swiper-slide {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover
            }
        }

    }

    .content-title{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
    }
    .content-text{
        font-size: 14px;
        line-height: 2;
    }
    .icon-list{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-flow: wrap;
        .icon-list-item{
            color: #949494 !important;
            width: 10%;
            margin-bottom: 20px;
            text-align: center;

            .iconfont{
                font-size: 38px;
            }
        }
    }
    .map-content {
        width: 840px;
        height: 500px;
        position: relative;
    }
</style>
<style>
    .gallery-thumbs .swiper-slide-active{
        border: 2px solid #e44646 !important;
    }
</style>

